import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

const fieldLabel = "text-xs font-mono uppercase tracking-[0.15em] text-slate-700 font-medium";

/** Computed (active) classes for one availability slot button. */
function slotClasses(selected, available) {
  if (selected) return "bg-slate-900 text-slate-50 border-slate-900";
  if (available) return "border-slate-300 hover:border-slate-900";
  return "border-slate-100 text-slate-300 cursor-not-allowed line-through";
}

/** Step 3 — pick a date and an available on-site time slot (skipped for services with no on-site visit). */
export function ScheduleStep({ form }) {
  const { hasOnsite, date, setDate, loadSlots, onsiteMinutes, slotsLoading, slots, time, setTime } = form;
  return (
    <div data-testid="step-datetime" className="space-y-6 fade-up">
      <h2 className="font-display text-3xl tracking-tight">Pick a date & time</h2>
      {!hasOnsite ? (
        <div className="border border-slate-300 p-6 text-slate-600">Your selected services don't require an on-site visit. You can skip scheduling.</div>
      ) : (
        <>
          <div>
            <Label className={fieldLabel}>Date</Label>
            <Input data-testid="booking-date" type="date" min={new Date().toISOString().split("T")[0]} value={date}
              onChange={(e) => { setDate(e.target.value); loadSlots(e.target.value); }} className="mt-2 rounded-none border-slate-300 max-w-xs" />
            <p className="text-xs text-slate-400 mt-2">On-site duration ≈ {onsiteMinutes} min + travel buffer. We check all photographers' availability.</p>
          </div>
          {date && (
            <div>
              <Label className={fieldLabel}>Available times</Label>
              {slotsLoading ? <div className="mt-3 text-slate-400 flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Checking availability…</div> : (
                <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 mt-3" data-testid="slots-grid">
                  {slots.map((s) => (
                    <button key={s.time} data-testid={`slot-${s.time}`} disabled={!s.available} onClick={() => setTime(s.time)}
                      className={`py-2 text-sm font-mono border transition-all ${slotClasses(time === s.time, s.available)}`}>
                      {s.time}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
